"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcTemplate = class UcTemplate extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
        this.$$cache_emailAddress = new core_1.ComponentValueCache(this, "emailAddress", "Template.emailAddress");
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    context;
    onContext(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("context");
    }
    labelAlign;
    objectTypes;
    async $$load_objectTypes() {
        return this.$fn.getEnumValuesFromSchema('ObjectTypes');
    }
    templateTypes;
    async $$load_templateTypes() {
        return this.$fn.getEnumValuesFromSchema('TemplateTypes');
    }
    sampleDataSearchResult;
    previewData;
    emailAddress;
    async $$load_emailAddress() {
        return this.$app.auth.user.email;
    }
    ux;
    b_4892266742011185_style;
    b_5970972589163186_options;
    b_785371160721131_style;
    b_253425746720918_options;
    b_2748386552601189_style;
    b_1712041292317581_options;
    b_539880003873724_style;
    b_6324823719113312_options;
    b_219110658038496_style;
    b_3034545286442485_options;
    b_4556014673857397_style;
    b_7786722825496231_options;
    dataMembers = ['labelAlign', 'objectTypes', 'templateTypes', 'sampleDataSearchResult', 'previewData', 'emailAddress', 'ux', 'b_4892266742011185_style', 'b_5970972589163186_options', 'b_785371160721131_style', 'b_253425746720918_options', 'b_2748386552601189_style', 'b_1712041292317581_options', 'b_539880003873724_style', 'b_6324823719113312_options', 'b_219110658038496_style', 'b_3034545286442485_options', 'b_4556014673857397_style', 'b_7786722825496231_options'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                labelAlign: "left",
                objectTypes: null,
                templateTypes: null,
                sampleDataSearchResult: null,
                previewData: null,
                emailAddress: null,
                ux: null,
                b_4892266742011185_style: {
                    width: "20px",
                },
                b_5970972589163186_options: {
                    lineNumbers: true,
                    matchBrackets: true,
                    continueComments: "Enter",
                    extraKeys: {
                        "Ctrl-Q": "toggleComment",
                    },
                },
                b_785371160721131_style: {
                    width: "20px",
                },
                b_253425746720918_options: {
                    lineNumbers: true,
                    matchBrackets: true,
                    continueComments: "Enter",
                    extraKeys: {
                        "Ctrl-Q": "toggleComment",
                    },
                },
                b_2748386552601189_style: {
                    width: "20px",
                },
                b_1712041292317581_options: {
                    lineNumbers: true,
                    matchBrackets: true,
                    continueComments: "Enter",
                    extraKeys: {
                        "Ctrl-Q": "toggleComment",
                    },
                },
                b_539880003873724_style: {
                    width: "20px",
                },
                b_6324823719113312_options: {
                    lineNumbers: true,
                    matchBrackets: true,
                    continueComments: "Enter",
                    extraKeys: {
                        "Ctrl-Q": "toggleComment",
                    },
                },
                b_219110658038496_style: {
                    width: "20px",
                },
                b_3034545286442485_options: {
                    lineNumbers: true,
                    matchBrackets: true,
                    continueComments: "Enter",
                    extraKeys: {
                        "Ctrl-Q": "toggleComment",
                    },
                },
                b_4556014673857397_style: {
                    width: "20px",
                },
                b_7786722825496231_options: {
                    lineNumbers: true,
                    matchBrackets: true,
                    continueComments: "Enter",
                    extraKeys: {
                        "Ctrl-Q": "toggleComment",
                    },
                },
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_4882 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_4881 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_4882,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_4881],
        });
        return {
            act_7315092382398562_reloadComponentData_4882,
            evh_7315092382398562_reload_4881,
            evh_7315092382398562_reload,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcTemplate.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcTemplate.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], UcTemplate.prototype, "context", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('context'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcTemplate.prototype, "onContext", null);
UcTemplate = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcTemplate);
exports.default = UcTemplate;
vue_property_decorator_1.Vue.component("UcTemplate", UcTemplate);
